import React from "react";
import { useSubheader } from "../../../../_metronic/layout";
export const TodaysLeaderboard = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Today's Leaderboard");
    return (
        <div>
     
        </div>
    )
}